import React, {useEffect, useRef, useState} from "react";
import {Link} from "react-router-dom";
import useCartButtons from "../../products/useCartButtons";
import useProductPrice from "../../products/useProductPrice";
import useTextTools from "../../shared/useTextTools";

import {FarmyColumn, FarmyColumnSet} from "../../layouts/components/FarmyColumns";
import UnavailableCartItem from "../Unavailable.CartItem";

const CartSidebarItem = (props) => {
  const {lineItem, firstLoad} = props;
  const {productData: product} = lineItem;
  const {truncate} = useTextTools();

  const [hide, setHide] = useState(!firstLoad);
  const [height, setHeight] = useState(0);
  const contentRef = useRef();

  const maxWords = 7;

  const cartOptions = {
    callerLocation: "cart-sidebar-desktop"
  };

  const calculateHeight = () => {
    if (!contentRef?.current) return;
    const newHeight = contentRef.current.firstChild.clientHeight;
    return `${newHeight}px`;
  };

  const {
    IncreaseButton,
    DecreaseButton,
    RemoveButton,
    parsedQuantity,
    isLastVariant
  } = useCartButtons(product, cartOptions);

  const {
    price,
    currency
  } = useProductPrice(product);

  useEffect(() => {
    if (lineItem?.remove) setHide(true);
    else if (hide) setHide(false);
    else setHide(false);
  }, [lineItem?.remove, lineItem?.add]);

  useEffect(() => {
    setHeight(calculateHeight());
  }, []);

  return <div
    className={`
      background-color-almost-white
      border-radius-xs
      font-size-body-smaller
      transition-all-fast
      overflow-hidden
      flex-shrink-0
      ${lineItem?.addable_to_cart ? null : "unavailable-wrapper"}
    `}
    style={{
      height: hide ? 0 : (height || null),
      marginBottom: hide ? "-10px" : null
    }}
    ref={contentRef}
  >
    <FarmyColumnSet className="position-relative">
      {!lineItem?.addable_to_cart &&
        <UnavailableCartItem removeButton={RemoveButton} product={product}/>
      }

      <FarmyColumnSet
        gap="10px"
        className={`
          padding-10
          full-width
          ${lineItem?.addable_to_cart ? "" : "disable-action unavailable"}
        `}
      >
        {/* Image */}
        <FarmyColumn width="26%">
          <img
            alt={product?.name}
            src={product?.image?.xs}
            className="full-width border-radius-xs overflow-hidden"
          />
        </FarmyColumn>

        <FarmyColumn width="100%" className="flex flex-direction-column gap-10">
          {/* First Row */}
          <FarmyColumnSet gap="10px">
            {/* Product name (truncated) */}
            <FarmyColumn>
              <Link to={product?.seo_url} className="text-color-body">
                <div className="font-weight-600" style={{lineHeight: "1.2em"}}>
                  {truncate(product?.name, maxWords)}
                </div>
              </Link>
            </FarmyColumn>

            {/* Remove button (corner cross) */}
            <FarmyColumn
              width="20px"
              className={`
              flex
              flex-direction-column
              align-items-flex-end
              justify-content-space-between
              flex-grow-0
            `}
            >
              <RemoveButton
                product={product}
                size="sm"
                color="transparent"
                className="font-size-body-bigger text-color-dimmed"
                style={{
                  fontSize: "16px",
                  lineHeight: 0,
                  padding: 0
                }}
              />
            </FarmyColumn>
          </FarmyColumnSet>

          <FarmyColumnSet gap="10px" className="align-items-center">
            <FarmyColumn width="55%" strict={true}>
              {/* Cart buttons */}
              <FarmyColumnSet
                className={`
                align-items-center
                sidebar-item-cart-buttons
                background-color-lightest-grey
                border-radius-sm
                font-size-body-smaller
              `}
              >
                <FarmyColumn>
                  <DecreaseButton
                    disabled={!lineItem?.addable_to_cart}
                    product={product}
                    size="sm"
                    color="transparent"
                    className={`
                full-width
                active-shadow
                text-color-green
                font-family-alata
                font-weight-100
              `}
                    style={{
                      borderBottomRightRadius: 0,
                      borderTopRightRadius: 0,
                      paddingTop: 0,
                      paddingBottom: 0,
                      transition: "box-shadow 100ms",
                      fontSize: "18px",
                      lineHeight: "1em"
                    }}
                  />
                </FarmyColumn>
                <FarmyColumn
                  width="50%"
                  className={`
                  flex
                  full-width
                  align-items-center
                  justify-content-center
                  margin-top-5
                  margin-bottom-5
                `}
                >
                  <div className="text-align-center font-size-body-smaller">
                    {parsedQuantity?.quantity}
                    <span className="font-size-body-tiny text-color-body-light">
                      &nbsp;{parsedQuantity?.unit}
                    </span>
                  </div>
                </FarmyColumn>
                <FarmyColumn>
                  <IncreaseButton
                    disabled={!lineItem?.addable_to_cart}
                    product={product}
                    size="sm"
                    color="transparent"
                    className={`
                full-width
                font-family-alata
                font-weight-100
                ${isLastVariant ? "text-color-dimmed" : "text-color-green active-shadow"}
              `}
                    style={{
                      borderBottomLeftRadius: 0,
                      borderTopLeftRadius: 0,
                      paddingTop: 0,
                      paddingBottom: 0,
                      transition: "box-shadow 100ms",
                      fontSize: "18px",
                      lineHeight: "1em"
                    }}
                  />
                </FarmyColumn>
              </FarmyColumnSet>
            </FarmyColumn>

            {/* Item total price */}
            <div className="font-weight-600 font-size-body-smaller">
              {currency}{price}
            </div>
          </FarmyColumnSet>
        </FarmyColumn>
      </FarmyColumnSet>
    </FarmyColumnSet>
  </div>;
};

export default CartSidebarItem;
